import { render, staticRenderFns } from "./Dimensions.vue?vue&type=template&id=57430ab3&"
import script from "./Dimensions.vue?vue&type=script&lang=js&"
export * from "./Dimensions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports